import { render, staticRenderFns } from "./Customs_Declaration.vue?vue&type=template&id=627cf1d9&scoped=true&"
import script from "./Customs_Declaration.vue?vue&type=script&lang=js&"
export * from "./Customs_Declaration.vue?vue&type=script&lang=js&"
import style0 from "./Customs_Declaration.vue?vue&type=style&index=0&id=627cf1d9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627cf1d9",
  null
  
)

export default component.exports